/* No cart requests or checkout overrides. Sticky clicks use the original ATC. */
(() => {
  'use strict';
  if (window.__jftBrandButtonsV1) return;
  window.__jftBrandButtonsV1 = true;

  const PRODUCT = 'product-info';
  const DRAWER = '.ocu-cart-drawer';
  const products = new Map();
  const drawers = new Map();
  const dirty = new Set();
  let frame = 0;
  let sticky = null;
  let stickyFrame = 0;
  let forwardingStickyClick = false;

  function queueSticky() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => {
      stickyFrame = 0;
      updateSticky();
    });
  }

  function clarifyBundleCurrency() {
    // The campaign price helper formats current Shopify amounts and currency.
    // No special case for a particular offer price belongs in these buttons.
  }

  function mainProduct() {
    return Array.from(products.values()).find(({ root }) => root.isConnected
      && root.matches('product-info[id^="MainProduct-"]')
      && !root.closest('quick-add-modal'));
  }

  function overlayIsOpen() {
    const overlays = document.querySelectorAll(
      '.ocu-cart-drawer.ocu-visible, cart-drawer.active, dialog[open],'
      + ' modal-dialog[open], product-modal[open], .menu-drawer-container[open],'
      + ' [role="dialog"][aria-modal="true"]'
    );
    return Array.from(overlays).some((element) => {
      // Some apps leave aria-modal on a closed, off-canvas drawer.
      if (element.matches('.ocu-cart-drawer')) return element.classList.contains('ocu-visible');
      if (element.matches('cart-drawer')) return element.classList.contains('active');
      if (element.matches('dialog[open], modal-dialog[open], product-modal[open], .menu-drawer-container[open]')) return true;
      if (element.getAttribute('aria-hidden') === 'true' || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.visibility !== 'hidden' && style.opacity !== '0'
        && rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0
        && rect.left < innerWidth && rect.top < innerHeight;
    });
  }

  function updateSticky() {
    clarifyBundleCurrency();
    const controller = mainProduct();
    const original = controller?.root.querySelector('[data-jft-product-cta]');
    if (!original || document.querySelector('[data-apology-bundle-add]')) {
      sticky?.remove();
      sticky = null;
      return;
    }
    if (!sticky) {
      sticky = document.createElement('button');
      sticky.type = 'button';
      sticky.className = 'jft-brand-cta jft-sticky-atc';
      sticky.setAttribute('aria-hidden', 'true');
      sticky.tabIndex = -1;
      const label = document.createElement('span');
      label.setAttribute('data-jft-sticky-label', '');
      const amount = document.createElement('span');
      amount.className = 'jft-brand-cta__price';
      amount.setAttribute('data-jft-sticky-price', '');
      amount.hidden = true;
      sticky.append(label, amount);
      sticky.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const source = mainProduct()?.root.querySelector('[data-jft-product-cta]');
        if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true'
          || source.classList.contains('loading') || forwardingStickyClick) return;
        if (source.form?.elements.namedItem('quantity')?.validity.valid === false) return;
        // Do not create a second cart request or bypass Zipify, validation, or add-ons.
        forwardingStickyClick = true;
        sticky.disabled = true;
        sticky.setAttribute('aria-busy', 'true');
        source.click();
        queueSticky();
        // Also guard rapid taps when an app does not expose its own loading state.
        setTimeout(() => {
          forwardingStickyClick = false;
          queueSticky();
        }, 700);
      });
      document.body.append(sticky);
    }

    const amount = original.querySelector('[data-jft-product-price]');
    // The source amount is intentionally hidden on the primary button.
    const priceText = amount?.textContent || '';
    const labelText = original.querySelector('span')?.textContent.trim() || 'Add to cart';
    const label = sticky.querySelector('[data-jft-sticky-label]');
    if (label.textContent !== labelText) label.textContent = labelText;
    showPrice(sticky.querySelector('[data-jft-sticky-price]'), priceText);
    const busy = forwardingStickyClick || original.getAttribute('aria-busy') === 'true'
      || original.classList.contains('loading') || original.getAttribute('aria-disabled') === 'true';
    const disabled = busy || original.disabled || !priceText;
    if (sticky.disabled !== disabled) sticky.disabled = disabled;
    if (sticky.getAttribute('aria-busy') !== String(busy)) sticky.setAttribute('aria-busy', String(busy));

    const editing = document.activeElement?.matches(
      'textarea, select, [contenteditable="true"], input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])'
    );
    const visible = matchMedia('(max-width: 749px)').matches
      && original.getClientRects().length > 0 && original.getBoundingClientRect().bottom < 0
      && !editing && !overlayIsOpen();
    sticky.classList.toggle('is-visible', visible);
    const hiddenValue = String(!visible);
    if (sticky.getAttribute('aria-hidden') !== hiddenValue) sticky.setAttribute('aria-hidden', hiddenValue);
    if (sticky.tabIndex !== (visible ? 0 : -1)) sticky.tabIndex = visible ? 0 : -1;
  }

  // Shopify money values have two implied decimal places, including JPY/KRW.
  // Keep the merchant's money format instead of assuming USD or parsing text.
  function formatMoney(cents, format) {
    if (!Number.isSafeInteger(cents) || cents < 0 || typeof format !== 'string') return '';
    const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) return '';
    const formats = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
    };
    const spec = formats[token[1]];
    if (!spec) return '';
    const parts = (cents / 100).toFixed(spec[0]).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, spec[1]);
    const template = document.createElement('template');
    template.innerHTML = format.replace(token[0], parts.join(spec[2]));
    return template.content.textContent.trim();
  }

  function readConfig(root) {
    try {
      return JSON.parse(root.querySelector('[data-jft-price-config]')?.textContent || 'null');
    } catch (_) {
      return null;
    }
  }

  function showPrice(element, text) {
    if (!element) return;
    if (element.textContent !== text) element.textContent = text;
    const hidden = !text || element.matches('[data-jft-product-price]');
    if (element.hidden !== hidden) element.hidden = hidden;
  }

  function schedule(controller) {
    dirty.add(controller);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const pending = Array.from(dirty);
      dirty.clear();
      pending.forEach((item) => {
        if (item.root.isConnected) item.update();
      });
    });
  }

  function productPrice(controller) {
    const { root, config } = controller;
    const button = root.querySelector('[data-jft-product-cta]');
    const price = button?.querySelector('[data-jft-product-price]');
    if (!price) return;
    const form = button.form;
    const variantId = form?.elements.namedItem('id')?.value;
    const quantityInput = form?.elements.namedItem('quantity');
    const quantity = quantityInput ? Number(quantityInput.value) : 1;
    const unavailable = button.disabled || button.getAttribute('aria-disabled') === 'true'
      || button.classList.contains('loading');

    // Hide rather than display the previous variant's price while Dawn loads.
    if (unavailable || !config || !variantId || String(config.variantId) !== variantId
      || !Number.isSafeInteger(quantity) || quantity < 1
      || (quantityInput && !quantityInput.validity.valid)) {
      showPrice(price, '');
      return;
    }

    let unitPrice = Number(config.price);
    const cartQuantity = Number(quantityInput?.dataset.cartQuantity || 0);
    const eligibleQuantity = quantity + (Number.isFinite(cartQuantity) ? cartQuantity : 0);
    let threshold = 0;
    for (const priceBreak of config.priceBreaks || []) {
      const minimum = Number(priceBreak.minimum_quantity);
      const amount = Number(priceBreak.price);
      if (minimum >= threshold && eligibleQuantity >= minimum
        && Number.isSafeInteger(amount) && amount >= 0) {
        threshold = minimum;
        unitPrice = amount;
      }
    }
    showPrice(price, formatMoney(unitPrice * quantity, config.moneyFormat));
  }

  function watchProduct(root) {
    if (products.has(root) || !root.querySelector('[data-jft-product-cta]')) return;
    const controller = { root, config: readConfig(root), update: () => {
      productPrice(controller);
      queueSticky();
    } };
    controller.observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => !mutation.target.closest?.('[data-jft-product-price]'))) {
        schedule(controller);
      }
    });
    controller.observer.observe(root, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class', 'data-cart-quantity', 'min', 'max', 'step'],
    });
    products.set(root, controller);
    controller.update();
  }

  function drawerPrice(controller) {
    // Remove only our old duplicate amount, never Zipify's label or summary.
    controller.root.querySelectorAll('.ocu-checkout-button [data-jft-cart-price]')
      .forEach((price) => price.remove());
  }

  function watchDrawer(root) {
    if (drawers.has(root)) return;
    const controller = { root, update: () => drawerPrice(controller) };
    controller.observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => {
        const element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return !element?.closest('[data-jft-cart-price]');
      })) schedule(controller);
    });
    controller.observer.observe(root, { subtree: true, childList: true, characterData: true });
    drawers.set(root, controller);
    controller.update();
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.(PRODUCT)) watchProduct(node);
    if (node.matches?.(DRAWER)) watchDrawer(node);
    node.querySelectorAll(PRODUCT).forEach(watchProduct);
    node.querySelectorAll(DRAWER).forEach(watchDrawer);
    // A section can insert a buy-button into an existing product-info element.
    if (node.matches?.('[data-jft-product-cta]') || node.querySelector('[data-jft-product-cta]')) {
      const root = node.closest?.(PRODUCT);
      if (root) watchProduct(root);
    }
  }

  function start() {
    scan(document);
    queueSticky();
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', () => {
      products.forEach(schedule);
      queueSticky();
    }, { passive: true });
    window.visualViewport?.addEventListener('resize', queueSticky, { passive: true });
    window.visualViewport?.addEventListener('scroll', queueSticky, { passive: true });
    document.addEventListener('focusin', queueSticky);
    document.addEventListener('focusout', queueSticky);
    ['input', 'change'].forEach((type) => document.addEventListener(type, (event) => {
      const root = event.target.closest?.(PRODUCT);
      const controller = products.get(root);
      if (controller) schedule(controller);
    }));

    // Dawn supplies the freshly rendered Liquid response for the selected variant.
    // Read only our small config from it; never replace the real submit button.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        products.forEach((controller, root) => {
          if (String(root.dataset.originalSection || root.dataset.section) !== String(data.sectionId)) return;
          const configs = data.html?.querySelectorAll('[data-jft-price-config]') || [];
          let nextConfig = null;
          for (const script of configs) {
            try {
              const parsed = JSON.parse(script.textContent);
              if (String(parsed.variantId) === String(data.variant?.id)) nextConfig = parsed;
            } catch (_) { /* Fail closed if a third-party response is malformed. */ }
          }
          controller.config = nextConfig;
          schedule(controller);
        });
      });
      if (PUB_SUB_EVENTS.quantityUpdate) {
        subscribe(PUB_SUB_EVENTS.quantityUpdate, () => products.forEach(schedule));
      }
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) mutation.addedNodes.forEach(scan);
      // Disconnect per-section observers when Shopify swaps/unloads sections.
      for (const collection of [products, drawers]) {
        collection.forEach((controller, root) => {
          if (!root.isConnected) {
            controller.observer.disconnect();
            dirty.delete(controller);
            collection.delete(root);
          }
        });
      }
      if (mutations.some((mutation) => !mutation.target.closest?.('.jft-sticky-atc'))) queueSticky();
    });
    observer.observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden'],
    });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('product-info:loaded', (event) => scan(event.target));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();